import { render, staticRenderFns } from "./OutboundShipments.vue?vue&type=template&id=06f1d322&scoped=true"
import script from "./OutboundShipments.vue?vue&type=script&lang=js"
export * from "./OutboundShipments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f1d322",
  null
  
)

export default component.exports